import { select } from 'redux-saga/effects';

import authenticationTokenSelector from '../selectors/authenticationSelectors';

export default function* getAuthenticationToken() {
  const token = authenticationTokenSelector(yield select());
  return token;
}
